import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import type { LacTenantOverviewDateRange } from '../../../types/lac';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacKnowledgeBaseDocumentAnalyticsQuery(
  tenantName?: string | null,
  range?: LacTenantOverviewDateRange,
) {
  const scopedTenantName = tenantName?.trim() || null;

  return useQuery({
    queryKey: lacQueryKeys.knowledgeBaseDocumentAnalytics(
      scopedTenantName,
      range ?? null,
    ),
    queryFn: () =>
      lacAnalyticsService.listKnowledgeBaseDocumentAnalytics({
        tenantName: scopedTenantName ?? undefined,
        range,
      }),
  });
}
